exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.modal .modal-m .modal-footer {\n  padding: 0px;\n}\n.modal .modal-m .modal-header {\n  padding-bottom: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0e5f1957","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/InvoiceCancellation.vue
// module id = 1484
// module chunks = 0